<ion-content>
  <div class="upgrade-feature-banner" *ngIf="!featureEnabled">
    <div class="flex-space-between" style="align-items: center">
      Upgrade to add your own knowledge base for AI-generated responses
      <ion-button
        fill="outline"
        color="light"
        class="btn-small"
        [routerLink]="'/upgrade'"
        [queryParams]="{ plan: 'pro' }"
      >
        <ion-icon name="arrow-up-circle" class="padded-icon"></ion-icon>
        Upgrade account
      </ion-button>
    </div>
  </div>

  <div class="padded">
    <!-- Top Buttons -->
    <div style="display: flex; justify-content: space-between; align-items: center">
      <ion-button
        (click)="openRunQueryModal()"
        style="margin: 10px"
        fill="clear"
        color="dark"
        class="button-dark-border"
        [disabled]="!featureEnabled"
      >
        <ion-icon name="flask"></ion-icon>
        <span class="text-with-left-icon"> Test AI-generated response</span>
      </ion-button>
      <div>
        <ion-button
          (click)="addKnowledgeBaseSource()"
          [disabled]="!featureEnabled"
          fill="clear"
          color="dark"
          class="button-dark-border"
        >
          <ion-icon name="globe-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Add Source </span>
        </ion-button>
        <ion-button (click)="createArticle()" style="margin: 10px" [disabled]="!featureEnabled" color="dark">
          <ion-icon name="newspaper-outline"></ion-icon>
          <span class="text-with-left-icon hidden-sm"> Create Article </span>
        </ion-button>
      </div>
    </div>

    <!-- Segment Navigation using Router -->
    <ion-segment mode="md">
      <ion-segment-button
        value="/dashboard/knowledge/articles"
        routerLink="/dashboard/knowledge/articles"
        routerLinkActive="segment-button-checked"
      >
        <ion-label>Articles & Sources</ion-label>
      </ion-segment-button>
      <ion-segment-button
        value="/dashboard/knowledge/suggestions"
        routerLink="/dashboard/knowledge/suggestions"
        routerLinkActive="segment-button-checked"
      >
        <ion-label>Suggestions</ion-label>
      </ion-segment-button>
    </ion-segment>

    <!-- Child Route Content -->
    <router-outlet></router-outlet>
  </div>
</ion-content>

<!-- Modal for AI Tester -->
<ion-modal [isOpen]="showRunQueryModal" (willDismiss)="onDismissRunQueryModal()" class="run-query-modal modal-large">
  <ng-template>
    <article style="height: 100%">
      <app-admin-ai-tester></app-admin-ai-tester>
    </article>
  </ng-template>
</ion-modal>
